function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "12",
  fill: "#45B834"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M15.916 6.504a.85.85 0 00-.52.252L9.75 12.54l-1.146-1.174a.843.843 0 00-1.208 0L6.25 12.541a.885.885 0 000 1.236l2.896 2.967a.84.84 0 001.207 0l7.397-7.577a.885.885 0 000-1.236l-1.146-1.175A.843.843 0 0016 6.5l-.084.004zm.084.508c.094 0 .184.038.25.106l1.146 1.175a.364.364 0 010 .512L10 16.382a.348.348 0 01-.5 0l-2.896-2.967a.364.364 0 010-.512l1.146-1.175a.348.348 0 01.5 0l1.323 1.356c.098.1.256.1.354 0L15.75 7.12a.345.345 0 01.25-.107z"
}))));